import { generateBaseQueryKeysList } from '@/queries/utils';

export const BANNED_TAIL_NUMBERS_KEYS = {
  main: 'banned-tail-numbers',
};

export const bannedTailNumbersQueryKeys = generateBaseQueryKeysList(BANNED_TAIL_NUMBERS_KEYS.main);
